/**
 * Turkish locale overrides for DevExtreme DataGrid.
 *
 * DevExtreme's built-in tr.json has 47 DataGrid/Pager keys that ship
 * with English values. This module provides Turkish translations for all of them.
 *
 * Usage: call `loadMessages(dxTrOverrides)` after loading the vendor tr.json.
 *
 * Rule 15: Root cause fix — vendor locale incomplete, custom overrides fill the gap.
 * DRY: Shared between web-tms and web-wms via @axon/grid-devextreme package.
 */
export const dxTrOverrides = {
  tr: {
    // Column fixing
    'dxDataGrid-columnFixingFix': 'Sabitle',
    'dxDataGrid-columnFixingLeftPosition': 'Sol',
    'dxDataGrid-columnFixingRightPosition': 'Sağ',
    'dxDataGrid-columnFixingStickyPosition': 'Yapışkan',
    'dxDataGrid-columnFixingUnfix': 'Sabitlemeyi Kaldır',

    // Column moving
    'dxDataGrid-moveColumnToTheLeft': 'Sola taşı',
    'dxDataGrid-moveColumnToTheRight': 'Sağa taşı',

    // Header filter
    'dxDataGrid-headerFilterEmptyValue': '(Boş)',
    'dxDataGrid-headerFilterIndicatorLabel': "'{0}' sütunu için filtre seçeneklerini göster",
    'dxDataGrid-headerFilterLabel': 'Filtre seçenekleri',

    // Column chooser
    'dxDataGrid-emptyHeaderColumnChooserText': 'sütun seçici',
    'dxDataGrid-emptyHeaderWithColumnChooserText': 'Sütunları görüntülemek için {0} kullanın',
    'dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText':
      '{0} kullanın veya grup panelinden bir sütunu sürükleyin',
    'dxDataGrid-emptyHeaderWithGroupPanelText': 'Grup panelinden buraya bir sütun sürükleyin',

    // Summary
    'dxDataGrid-summaryMin': 'Min: {0}',
    'dxDataGrid-summaryMax': 'Maks: {0}',

    // Master-detail & adaptive
    'dxDataGrid-masterDetail': 'Detay hücresi',
    'dxDataGrid-ariaAdaptiveCollapse': 'Ek verileri gizle',
    'dxDataGrid-ariaAdaptiveExpand': 'Ek verileri göster',

    // ARIA accessibility
    'dxDataGrid-ariaColumnHeader': 'Sütun başlığı',
    'dxDataGrid-ariaEditForm': 'Düzenleme formu',
    'dxDataGrid-ariaEditableCell': 'Düzenlenebilir',
    'dxDataGrid-ariaDeletedCell': 'Silindi',
    'dxDataGrid-ariaModifiedCell': 'Değiştirildi',
    'dxDataGrid-ariaError': 'Hata',
    'dxDataGrid-ariaCollapsedRow': 'Daraltılmış satır',
    'dxDataGrid-ariaExpandedRow': 'Genişletilmiş satır',
    'dxDataGrid-ariaNotSortedColumn': 'Sıralanmamış sütun',
    'dxDataGrid-ariaSortedAscendingColumn': 'Artan sırada sıralanmış sütun',
    'dxDataGrid-ariaSortedDescendingColumn': 'Azalan sırada sıralanmış sütun',
    'dxDataGrid-ariaSortIndex': 'Sıralama indeksi {0}',
    'dxDataGrid-ariaRevertButton': 'Değişiklikleri geri almak için Escape tuşuna basın',
    'dxDataGrid-ariaSearchBox': 'Arama kutusu',
    'dxDataGrid-ariaToolbar': 'Veri tablosu araç çubuğu',

    // AI features
    'dxDataGrid-aiPromptEditorTitle': 'AI İstem Düzenleyici',
    'dxDataGrid-aiDropDownAutofill': 'AI ile Otomatik Doldur',
    'dxDataGrid-aiDropDownClear': 'Verileri Temizle',
    'dxDataGrid-aiPromptEditorApplyButton': 'Uygula',
    'dxDataGrid-aiPromptEditorRegenerateButton': 'Yeniden Oluştur',
    'dxDataGrid-aiPromptEditorStopButton': 'Durdur',

    // Pager
    'dxPager-ariaLabel': 'Sayfa gezintisi',
    'dxPager-ariaPageNumber': 'Sayfa numarası',
    'dxPager-ariaPageSize': 'Sayfa boyutu',
    'dxPager-nextPage': 'Sonraki sayfa',
    'dxPager-prevPage': 'Önceki sayfa',
    'dxPager-page': 'Sayfa {0}',
    'dxPager-pageSize': 'Sayfa başına: {0}',
  },
};
